import { type FormInstance } from 'antd/es/form';

import type { AgentFormData } from '../../AgentModals/CreateAgentModal';

export const initializeSelectedSuggestions = (
  form: FormInstance<AgentFormData>,
  setSelectedSuggestions: (suggestions: Set<number>) => void,
) => {
  const savedSelected = form.getFieldValue('selectedSuggestions') || [];
  setSelectedSuggestions(new Set(savedSelected));
};

export const handleSuggestionClick = (
  suggestion: string,
  index: number,
  form: FormInstance<AgentFormData>,
  selectedSuggestions: Set<number>,
  setSelectedSuggestions: (suggestions: Set<number>) => void,
) => {
  const currentInstructions = form.getFieldValue('instructions') || '';
  const newInstructions = currentInstructions
    ? `${currentInstructions}\n\n${suggestion}`
    : suggestion;
  form.setFieldValue('instructions', newInstructions);

  // Update both local state (for immediate UI update) and form data (for persistence)
  const newSelected = new Set([...selectedSuggestions, index]);
  setSelectedSuggestions(newSelected);
  form.setFieldValue('selectedSuggestions', Array.from(newSelected));
};
